'use client';

import type { BoxProps } from '@mui/material/Box';

import Box from '@mui/material/Box';
import Portal from '@mui/material/Portal';
import LinearProgress from '@mui/material/LinearProgress';

import { Logo } from 'src/components/logo';

// ----------------------------------------------------------------------

type Props = BoxProps & {
  portal?: boolean;
};

export function SplashScreen({ portal = true, sx, ...other }: Props) {

  const content = (
    <Box sx={{ overflow: 'hidden' }}>
      <Box
        sx={{
          right: 0,
          width: 1,
          bottom: 0,
          height: 1,
          zIndex: 9998,
          display: 'flex',
          position: 'fixed',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          ...sx,
        }}
        {...other}
      >
        <Box
          sx={{
            width: 'fit-content',
            px: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
            mx: 'auto',
          }}
        >
          <Logo disableLink showVersion={false} width={60} height={60} />
          {/* Pure-CSS looping fill animation. Do NOT drive this with setState on a timer:
              repeated sync state updates keep interrupting and restarting React's
              concurrent transition render of the page behind the splash, which can
              livelock heavy pages (e.g. schedule) on the loading screen forever. */}
          <LinearProgress
            variant="determinate"
            value={0}
            color="inherit"
            sx={{
              width: 240,
              maxWidth: 240,
              mx: 'auto',
              '& .MuiLinearProgress-bar': {
                animation: 'splashFill 2.5s linear infinite',
              },
              '@keyframes splashFill': {
                '0%': { transform: 'translateX(-100%)' },
                '100%': { transform: 'translateX(0%)' },
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );

  if (portal) {
    return <Portal>{content}</Portal>;
  }

  return content;
}
